import { createAsyncThunk } from '@reduxjs/toolkit';
import instance from '../services/api';

// Define the types for Preferences and DashboardConfig
export interface Preference {
  [key: string]: any;
}

export interface DashboardConfig {
  DashboardName: string;
  WidgetName: string;
  PropertyType: string;
  Preferences: Record<string, any> | string;
  assetGUID?: string;
}

export const saveUserPerferences = createAsyncThunk<boolean, DashboardConfig, { rejectValue: string }>(
  'wellTestData/saveUserPerferences',
  async (dashboardConfig: DashboardConfig, { rejectWithValue }) => {
    const apiEndpoint = '/widgets/saveuserpreferences';
    try {
      const transformedObj = {
        dashboardName: dashboardConfig.DashboardName,
        widgetName: dashboardConfig.WidgetName,
        PropertyType: dashboardConfig.PropertyType,
        preferences: dashboardConfig.Preferences,
        ...(dashboardConfig.assetGUID && { assetGUID: dashboardConfig.assetGUID }),
      };

      const headers: Record<string, string> = {
        'Content-Type': 'application/json',
      };
      if (dashboardConfig.assetGUID) {
        headers['x-api-version'] = '2.0';
      }

      const response = await instance.post(apiEndpoint, transformedObj, {
        headers,
      });

      if (response?.status === 200) {
        return true;
      } else {
        return false;
      }
    } catch (error: any) {
      console.error('Error saving user preferences:', error.message);
      return rejectWithValue('Error saving preferences. Please try again!');
    }
  },
);

export interface ResetConfig {
  dashboardName: string;
  widgetName: string;
  assetGUID?: string;
}
export const resetUserPerferences = createAsyncThunk<{ data: Data }, ResetConfig>(
  'user/resetPreferences',
  async (config: ResetConfig) => {
    const apiEndpoint = '/widgets/ResetUserPreferences';

    try {
      const headers: Record<string, string> = {
        'Content-Type': 'application/json',
      };
      if (config.assetGUID) {
        headers['x-api-version'] = '2.0';
      }

      const response = await instance.post(apiEndpoint, config, {
        headers,
      });

      if (response?.data) {
        return response?.data;
      } else {
        return null;
      }
    } catch (error: any) {
      console.error('Error saving user preferences:', error.message);
    }
  },
);
